// extracted by mini-css-extract-plugin
export var link = "header-link-module--link--1R9-K";